import {
  ApiService,
  ParentModel,
  requestHelper,
  type AuthService,
  type ServiceStore,
} from '@blueprint/frontend-basics'

import { CreateShopDto, ShopDto } from '@/models/dtos/shop.dto.ts'

export class ShopService extends ApiService {
  private readonly backendURL: string

  constructor(
    serviceStore: ServiceStore,
    authService: AuthService,
    backendURL: string,
  ) {
    super(serviceStore, authService)
    this.backendURL = backendURL
  }

  public async createShop(createShopDto: CreateShopDto): Promise<ShopDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.post(
      `${this.backendURL}/team/${createShopDto.teamId}/shop/`,
      createShopDto,
      { headers },
    )
    return ParentModel.fromJson(response.data, ShopDto)
  }

  public async getShopsByTeam(
    teamId: string,
    page: number = 0,
    pageSize: number = 10,
  ) {
    const headers = await this.getAuthHeaders()
    const params = { page, pageSize }
    const response = await requestHelper.get(
      `${this.backendURL}/team/${teamId}/shop/`,
      { headers, params },
    )
    return ParentModel.fromPaginatedJson(response.data, ShopDto)
  }

  public async getShop(shopId: string): Promise<ShopDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.get(
      `${this.backendURL}/shop/${shopId}`,
      { headers },
    )
    return ParentModel.fromJson(response.data, ShopDto)
  }
}
